import { Autocomplete, Box, Checkbox, Chip, TextField, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAnnotatorsSelection } from './useAnnotatorsSelection';
import { AnnotatorResponse } from '../../types/response';

export const AnnotatorsSelection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    selectedAnnotators,
    handleRemoveAnnotator,
    annotators,
    annotatorInputValue,
    lastTypedAnnotatorValue,
    setAnnotatorInputValue,
    handleAddAnnotator,
    isAnnotatorsLoading,
  } = useAnnotatorsSelection();
  return (
    <Box id="annotators-selection">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
        <Typography variant="h6" sx={{ mb: theme.spacing(4) }}>
          {formatMessage({ id: 'createProjectWizard.step.allocation.selectAnnotators.title' })}
        </Typography>
        <Typography variant="body2" sx={{ color: 'error.main' }}>
          *
        </Typography>
      </Box>
      <Autocomplete
        multiple
        disabled={isAnnotatorsLoading ?? false}
        options={annotators}
        value={selectedAnnotators}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        inputValue={annotatorInputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            lastTypedAnnotatorValue.current = newInputValue;
            setAnnotatorInputValue(newInputValue);
          }
        }}
        onChange={(event, newValue) => {
          const added = newValue.filter((n) => !selectedAnnotators.some((a) => a.id === n.id));

          const removed = selectedAnnotators.filter((a) => !newValue.some((n) => n.id === a.id));

          added.forEach(handleAddAnnotator);
          removed.forEach(handleRemoveAnnotator);
        }}
        getOptionDisabled={(option) => selectedAnnotators.some((a) => a.id === option.id)}
        renderOption={(props, option, { selected }) => {
          const { key, ...otherProps } = props;

          return (
            <Box
              key={key}
              component="li"
              {...otherProps}
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              <Checkbox checked={selected} />

              <span>{option.label}</span>
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={formatMessage({
              id: 'createProjectWizard.step.allocation.selectAnnotators.placeholder',
            })}
          />
        )}
      />
    </Box>
  );
};
